export function getPastedData(event) {
  const clipboardData =
    event.clipboardData ||
    event.originalEvent.clipboardData ||
    window.clipboardData;
  return clipboardData.getData("Text");
}
